import { createSelector, createStructuredSelector } from 'reselect'
import { createFormTargetSelector } from '../commons/FormReducer/utils'
import { createTargetDataSelector as createTargetFormSelector } from '../commons/FormReducer/reducer'
import { createReduxTargetSelector, createGetState } from '../commons/Redux/selector'

// export const url = '/api/session'

export const notNumber = (n) => !(parseInt(n) >= 0)

export const mapStateToProps = () => {

    const formTarget = createFormTargetSelector()
    const formData = createTargetFormSelector(formTarget)
    const storeTargetForm = createReduxTargetSelector(formTarget)

    const ps1FreqFuoriSeXQualcInasp = createSelector(
        formData,
        data => {
            const ps1= data && data.get('ps1')
            console.log('ps1?', ps1)
            return ps1
        }
    )

    const submitDisabled = createSelector(
        formData,
        (fd) => !fd 
        || notNumber(fd.get('ps1'))
        || notNumber(fd.get('ps2'))
        || notNumber(fd.get('ps3'))
        || notNumber(fd.get('ps4'))
        || notNumber(fd.get('ps5'))
        || notNumber(fd.get('ps6'))
        || notNumber(fd.get('ps7'))
        || notNumber(fd.get('ps8'))
        || notNumber(fd.get('ps9'))
        || notNumber(fd.get('ps10'))
    )

    const score = createSelector(
        formData,
        submitDisabled,
        (fd, disabled) => !!fd && !disabled && fd.get('ps1')*1
        +fd.get('ps2')*1
        +fd.get('ps3')*1
        +fd.get('ps4')*1
        +fd.get('ps5')*1
        +fd.get('ps6')*1
        +fd.get('ps7')*1
        +fd.get('ps8')*1
        +fd.get('ps9')*1
        +fd.get('ps10')*1        
    )

    const formProps = createStructuredSelector({
        storeTarget: storeTargetForm,
        // disabled: disableAllInputfields
    })

    const mapLocalStateToProps = createStructuredSelector({
        storeTargetForm,
        formProps,
        ps1FreqFuoriSeXQualcInasp,
        formData,
        submitDisabled,
        score
    })

    return createSelector(
        createGetState(),
        (_, props) => props,
        mapLocalStateToProps
    )
}
